<template>
<div>
  <div id="qyyxEdit" v-if="editFlag">
      <div id="kpxxView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="xqyxForm" :model="xqyxForm" label-width="0px" label-position="right" :rules="qyyxRules">
          <el-row class="tr mb5">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">展品类型</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="reserve1" style="text-align: left">
                <el-select size="small" v-model="xqyxForm.reserve1" class="searchSelect" clearable placeholder="全部" @change="changeReserve1(xqyxForm.reserve1)">
                  <el-option v-for="item in czlxData" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--
          <el-row class="tr mb5" v-if="xqyxForm.reserve1">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">详细分类</span>
            </el-col>
            <el-col :span="15">
              <el-form-item prop="czlxxl" style="text-align: left">
                <el-checkbox-group v-model="xqyxForm.czlxxlList">
                  <el-checkbox v-for="item in xxflData" :label="item.codeValue+item.codeName" :key="item.codeValue+item.codeName">{{item.codeName}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          -->
          <el-row class="tr mb5">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">展位类型</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="zwlx" style="text-align: left" v-if="xqyxForm.reserve1=='01'">
                <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="全部">
                    <el-option v-for="item in zwlxDataCL" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="zwlx" style="text-align: left" v-else-if="xqyxForm.reserve1 =='02'|| xqyxForm.reserve1 =='03'">
                <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="全部">
                    <el-option v-for="item in zwlxDataZBandJZ" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="zwlx" style="text-align: left" v-else>
                <el-select size="small" v-model="xqyxForm.zwlx" class="searchSelect" clearable placeholder="全部">
                    <el-option v-for="item in zwlxData" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="2" style="text-align: left">
              
            </el-col>
          </el-row>
          <el-row class="tr mb5" v-if="xqyxForm.zwlx == '1'">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">标准展位（每个9 平方米）</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="bzzwgs">
                <el-input size="small" v-model="xqyxForm.bzzwgs" placeholder="标准展位" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: left">
              <span class="mr5 vbm yxLabel">&nbsp;&nbsp;个</span>
            </el-col>
          </el-row>
          <el-row class="tr mb5" v-if="xqyxForm.zwlx == '2'">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">室内光地展位（需要特装搭建，18平方米起）</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="sngdzw">
                <!-- <el-input-number size="small" v-model="xqyxForm.sngdzw" :min="0" :max="1000" :precision="0" placeholder="室内光地展位"></el-input-number> -->
                <el-input size="small" v-model="xqyxForm.sngdzw" placeholder="室内光地展位" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: left">
              <span class="mr5 vbm yxLabel">&nbsp;&nbsp;平方米</span>
            </el-col>
          </el-row>
          <el-row class="tr mb5" v-if="xqyxForm.zwlx == '3'">
            <el-col :span="8">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">室外光地展位（100平方米起租，仅限
                <span style="color: red">举高</span>消防车类）</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="swgdzw">
                <!-- <el-input-number size="small" v-model="xqyxForm.swgdzw" :min="0" :max="1500" :precision="0" placeholder="室外光地展位"></el-input-number> -->
                <el-input size="small" v-model="xqyxForm.swgdzw" placeholder="室外光地展位" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: left">
              <span class="mr5 vbm yxLabel">&nbsp;&nbsp;平方米</span>
            </el-col>
          </el-row>
          <el-row style="text-align: center;">
            <span class="mr5 vbm yxLabel" style="color: red;font-size:16px">*注：1.只能选择一种展位类型作为报名信息
              <br/>2.选择标准展位不能进行特装
              <br/>3.光地展位分为室内光地展位和室外光地展位，价格相同

            </span>
          </el-row>

        <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;margin-top:50px">
          <el-col :span="24">
            <strong style="color: #2452ff;">近两届展会展位选择情况</strong>
          </el-col>
        </el-row>
          <el-row class="mb5" style="line-height: 29px;margin-top:30px;text-align: center;" >
            
          </el-row>
          <el-row style="text-align: center;">
            <div>
              <el-col :span="6">&nbsp;</el-col>
              <el-col :span="6"  v-for="(domain, index) in hisData" :key="index">
                <el-row class="mb10">
                  <strong>第{{domain.zhjs}}届标准展位：</strong>
                  <span v-text="domain.bzzwgs==null?'无':domain.bzzwgs+' 个'"></span>
                </el-row>
                <el-row class="mb10">
                  <strong>第{{domain.zhjs}}届光地展位：</strong>
                  <span v-text="domain.gdzwmj==null?'无':domain.gdzwmj+' m²'"></span>
                </el-row>
              </el-col>
              <el-col v-if="this.hisData.length == 0">
                <span>无历史展会数据</span>
              </el-col>
            </div>
          </el-row>

          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button v-if="zwyxData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">取消</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitXqyx('xqyxForm')">保存</el-button>
            </el-col>
          </el-row>
        </el-form>

        
      </div>
  </div>

  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
    <div id="qyzwyx" class="mb20">
        <el-row >
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="21">
            <el-form class="el-form demo-form-inline" ref="xqyxForm" :model="xqyxForm" label-width="150px" label-position="right">
            <el-row class="mb10">
              <strong>展品类型：</strong>
              <span  v-text="zwyxData.code_NAME"></span>
            </el-row>
            <!-- <el-row class="mb10">
              <strong>详细分类：</strong>
              <span  v-text="zwyxData.czlxxlmc"></span>
            </el-row> -->
            <el-row class="mb10" v-if="xqyxForm.zwlx == '1'">
              <strong>标准展位：</strong>
              <span v-text="(xqyxForm.bzzwgs==''||xqyxForm.bzzwgs==null)?'无':xqyxForm.bzzwgs+' 个'"></span>
              &nbsp;&nbsp;(标准展位：每个9平方米)
            </el-row>
            <el-row class="mb10" v-if="xqyxForm.zwlx == '2'">
              <strong>室内光地展位：</strong>
              <span v-text="(xqyxForm.sngdzw==''||xqyxForm.sngdzw==null)?'无':xqyxForm.sngdzw+' m²'"></span>
              &nbsp;&nbsp;(室内光地展位：需要特装搭建，18平方米起)
            </el-row>
            <el-row class="mb10" v-if="xqyxForm.zwlx == '3'">
              <strong>室外光地展位：</strong>
              <span v-text="(xqyxForm.swgdzw==''||xqyxForm.swgdzw==null)?'无':xqyxForm.swgdzw+' m²'"></span>
              &nbsp;&nbsp;(室外光地展位：仅限消防
              <span style="color:red;">举高</span>车类)
            </el-row>
            </el-form>
          </el-col>
           <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">编辑</el-button>
            </el-col>
        </el-row>
      </div>
  </div>
</div>
</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  
  name: "qyyxEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //需求意向表单
      xqyxForm: {
        reserve1:"",
        zwlx:"",
      //  czlxxlList:[],
        bzzwgs:"",
        sngdzw: "",
        swgdzw: ""
      },
      //需求意向uuid
      xqUuid: "",
      xqyxStatus:0,
      czlxData:[],
      qyyxRules:{
        reserve1: [
          { required: true, message: "请选择展品类型", trigger: "change" }
        ],
        zwlx: [
          { required: true, message: "请选择展位类型", trigger: "change" }
        ],
        bzzwgs:[
          // { required: true, message: "请填写标准展位个数", trigger: "blur" },
          // {
          //   pattern: /^([1-4])$/,
          //   message: "请输入1-4范围内的整数数字",
          //   trigger: "blur"
          // }
        ],
        sngdzw:[
          { required: true, message: "请填写室内光地展位面积", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "请输入整数数字",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              let v = this.xqyxForm.sngdzw;
              if (v != null && v != '' && v<18) {
                callback(new Error("室内光地展位面积应在18平方米到1500平方米之间"));
              } else if (v != null && v != '' && v>1500) {
                callback(new Error("室内光地展位面积应在18平方米到1500平方米之间"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
        ],
        swgdzw:[
          { required: true, message: "请填写室外光地展位面积", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "请输入整数数字",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              let v = this.xqyxForm.swgdzw;
              if (v != null && v != '' && v<100) {
                callback(new Error("室外光地展位面积应在100-1500平方米之间"));
              } else if (v != null && v != '' && v>1500) {
                callback(new Error("室外光地展位面积应在100-1500平方米之间"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
        ],
      },
      //历史数据
      hisData:[],
      zwlxData:[],
      zwlxDataCL:[],
      zwlxDataZBandJZ:[],
      zwyxData: [],
      editFlag: false,
      //详细分类
      xxflData:[],
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findXqyxByQyid(this.qyid);
        this.getZwHis(this.qyid);
      }
    }
  },
  created: function() {
    this.getCzlxData(); 
    this.getZwlxData();
    //this.findXqyxByQyid(this.qyid);
    //this.getZwHis(this.qyid);
  },
  methods: {
    getCzlxData: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/CZLX").then(
        function(res) {
          vm.czlxData=[];
          for(let i in res.data.result){
            if(res.data.result[i].codeValue !='99'){
              vm.czlxData.push(res.data.result[i]);
            }
          }
          //vm.czlxData = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    getZwlxData: function() {
      let vm = this;
      vm.$axios.get("/codelist/getCodetype/ZWLX").then(
        function(res) {
          vm.zwlxData = res.data.result;
          for(let i in res.data.result){
            if(res.data.result[i].codeValue != '1'){
              vm.zwlxDataCL.push(res.data.result[i]);
            }
            if(res.data.result[i].codeValue != '3'){
              vm.zwlxDataZBandJZ.push(res.data.result[i]);
            }
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //通过企业id查找企业参展展位需求意向
    findXqyxByQyid: function(qyid) {
      let vm = this;
      vm.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qyzwyx/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            
            this.zwyxData = JSON.parse(JSON.stringify(res.data.result[0]));
            if(this.zwyxData.czlxxlmc != null){
              var tempList = this.zwyxData.czlxxlmc.split(",");
              var czlxxlmc = "";
              for (var i in tempList) {
                czlxxlmc = czlxxlmc + tempList[i].substr(4) + "、";
              }
              this.zwyxData.czlxxlmc = czlxxlmc.substr(0, czlxxlmc.length - 1);
            }
            
            

            vm.xqyxStatus = 1; //修改
            //返回null时不自动带入min值
            if (res.data.result[0].bzzwgs != null)
              vm.xqyxForm.bzzwgs = res.data.result[0].bzzwgs;
            if (res.data.result[0].sngdzw != null)
              vm.xqyxForm.sngdzw = res.data.result[0].sngdzw;
            if (res.data.result[0].swgdzw != null)
              vm.xqyxForm.swgdzw = res.data.result[0].swgdzw;
            
            vm.xqyxForm.reserve1 = res.data.result[0].reserve1;
            vm.xqyxForm.zwlx = res.data.result[0].zwlx;

/*注掉小项 2024-11-26
            vm.xqyxForm.czlxxlList=[];
            if(res.data.result[0].czlxxlmc != null){
              var tempList = res.data.result[0].czlxxlmc.split(",");
              for (var i in tempList) {
                vm.xqyxForm.czlxxlList.push(tempList[i]);
              }
            }
*/

            vm.xqUuid = res.data.result[0].uuid;

          //  this.selectXxfl(vm.xqyxForm.reserve1);
            this.changeRules(vm.xqyxForm.reserve1);

            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
            }else{
                vm.editFlag = true;
            }
          } else {
            vm.xqyxStatus = 0; //新增
            vm.editFlag = true;
          }
          vm.$emit("getLoading", false);
        }.bind(vm),
        function(error) {
          vm.$emit("getLoading", false);
          console.log(error);
        }
      );
    },
    //需求意向提交
    submitXqyx: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("保存失败，请先填写企业基本信息后再填写其他信息", '提示', {
          confirmButtonText: '确定'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          /*暂时注掉小项
          if(vm.xqyxForm.czlxxlList.length <1 || vm.xqyxForm.czlxxlList.length>5){
            vm.$alert('请选择1-5种详细分类', '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            });
            console.log("error submit!!");
            return false;
          }
          */
          let n = (vm.xqyxForm.bzzwgs > 0)+(vm.xqyxForm.sngdzw > 0)+(vm.xqyxForm.swgdzw > 0);
          if(n==0){
            vm.$alert('请正确填写展位面积或个数信息', '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            });
            console.log("error submit!!");
            return false;
          }
          // else if(n>1){
          //   vm.$alert('只能选择一种展位需求意向填写', '提示', {
          //     confirmButtonText: '确定',
          //     type: 'warning'
          //   });
          //   console.log("error submit!!");
          //   return false;
          // }
          if(vm.xqyxForm.zwlx == '1' && (vm.xqyxForm.bzzwgs > 4 || vm.xqyxForm.bzzwgs < 1 )){
            vm.$alert('请填写1-4个标准展位', '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            });
            console.log("error submit!!");
            return false;
          }
          else{
            vm.$emit("getLoading", true);
            if (vm.xqyxStatus == 0) {
              /*暂时注掉小项
              let czlxxl = "";
              let czlxxlmc = "";
              for (let i in vm.xqyxForm.czlxxlList) {
                  let str = vm.xqyxForm.czlxxlList[i].substr(0, 4) + ",";
                  czlxxl += str;
                  czlxxlmc += vm.xqyxForm.czlxxlList[i] + ",";
              }
              */

              //新增
              var params = {
                qyid: vm.qyid,
                bzzwgs: vm.xqyxForm.bzzwgs,
                sngdzw: vm.xqyxForm.sngdzw,
                swgdzw: vm.xqyxForm.swgdzw,
                deleteFlag: "N",
                cjrid: vm.currentUser.userid,
                cjrmc: vm.currentUser.username,
                reserve1: vm.xqyxForm.reserve1,
                validateFlag: 'T',
              //  czlxxl: czlxxl.substr(0, czlxxl.length - 1),
              //  czlxxlmc: czlxxlmc.substr(0, czlxxlmc.length - 1),
                zwlx: vm.xqyxForm.zwlx
              };
              vm.$axios.post("/qyzwyx/doInsertXqyxByVO", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                    vm.$message({
                      message: "报名信息暂存成功",
                      type: "success"
                    });
                    vm.xqUuid = res.data.result.uuid;
                    vm.$emit("getLoading", false);
                    //this.$emit("getActive",  6);
                    vm.editFlag = false;
                    vm.findXqyxByQyid(this.qyid);

                    vm.xqyxStatus = 1;
                    //vm.submit();
                  } else {
                    vm.$message({
                      message: "报名信息暂存失败",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  vm.$emit("getLoading", false);
                  console.log(error);
                }
              );
            } else {
              //修改
              /*暂时注掉小项
              let czlxxl = "";
              let czlxxlmc = "";
              for (let i in vm.xqyxForm.czlxxlList) {
                  let str = vm.xqyxForm.czlxxlList[i].substr(0, 4) + ",";
                  czlxxl += str;
                  czlxxlmc += vm.xqyxForm.czlxxlList[i] + ",";
              }
              */

              var params = {
                uuid: vm.xqUuid,
                qyid: vm.qyid,
                bzzwgs: vm.xqyxForm.bzzwgs,
                sngdzw: vm.xqyxForm.sngdzw,
                swgdzw: vm.xqyxForm.swgdzw,
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.username,
                reserve1: vm.xqyxForm.reserve1,
                validateFlag: 'T',
              //  czlxxl: czlxxl.substr(0, czlxxl.length - 1),
              //  czlxxlmc: czlxxlmc.substr(0, czlxxlmc.length - 1),
                zwlx: vm.xqyxForm.zwlx
              };
              vm.$axios.post("/qyzwyx/doUpdateByVO", params).then(
                function(res) {
                  if (res.data.result > 0) {
                    vm.$message({
                      message: "报名信息暂存成功",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                    //this.$emit("getActive",  6);

                    vm.editFlag = false;
                    vm.findXqyxByQyid(this.qyid);
                    //提交展位预报名信息
                    //vm.submit();
                  } else {
                    vm.$message({
                      message: "报名信息暂存失败",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  vm.$emit("getLoading", false);
                  console.log(error);
                }
              );
            }
          } 
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
   
      }
       },
    //提交
    submit: function() {
      if (this.currentUser.deptid == "ZSYH") {
        //如果是展商用户跳转到确认页
        this.$router.push({
          name: "exhpredictionConfirm",
          query: { userid: this.currentUser.userid, type: "BJ" }
        });
      } else {
        //如果是管理员跳转到列表页
        this.$router.push({ name: "exhprediction" });
      }
    },
    //需求意向上一步
    cancelXqyx: function() {
      this.$emit("getActive",  4);
    },
    //获取历史展位选择情况
    getZwHis: function(qyid){
      let vm = this;
      let params={
        qyid: qyid,
        zhjs: window.config.zhjs
      }
      vm.$axios.post('/zwjbxxHis/doSearchHisListByVO' ,params).then(function (res) {
        if(res.data.code = '00000000') {
              this.hisData = res.data.result;
        }
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findXqyxByQyid(this.qyid);
    },
    changeReserve1: function(czlx){
    //  this.xqyxForm.czlxxlList = [];
      this.xqyxForm.zwlx="";
    //  this.selectXxfl(czlx);
      this.changeRules(czlx);
      
    },
    selectXxfl: function(czlx){
      let vm=this;
      vm.xxflData = [];
       vm.$axios.get("/codelist/getCodetype/CZLXXL").then(
        function(res) {
          for(let i in res.data.result){
            if(res.data.result[i].codeValue.substring(0,2) == czlx){
              vm.xxflData.push(res.data.result[i]);
            }
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    changeRules(czlx){
      switch(czlx){
        case '01':
          this.qyyxRules.sngdzw=[
            { required: true, message: "请填写室内光地展位面积", trigger: "blur" },
            {
              pattern: /^[0-9]+$/,
              message: "请输入整数数字",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                let v = this.xqyxForm.sngdzw;
                if (v != null && v != '' && v<60) {
                  callback(new Error("车辆及大型装备类室内光地展位面积应在60平方米到1500平方米之间"));
                } else if (v != null && v != '' && v>1500) {
                  callback(new Error("车辆及大型装备类室内光地展位面积应在60平方米到1500平方米之间"));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
          ];
          break;
        case '02':
          this.qyyxRules.sngdzw=[
            { required: true, message: "请填写室内光地展位面积", trigger: "blur" },
            {
              pattern: /^[0-9]+$/,
              message: "请输入整数数字",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                let v = this.xqyxForm.sngdzw;
                if (v != null && v != '' && v<18) {
                  callback(new Error("室内光地展位面积应在18平方米到400平方米之间"));
                } else if (v != null && v != '' && v>400) {
                  callback(new Error("室内光地展位面积应在18平方米到400平方米之间"));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
          ];
          break;
        case '03':
          this.qyyxRules.sngdzw=[
            { required: true, message: "请填写室内光地展位面积", trigger: "blur" },
            {
              pattern: /^[0-9]+$/,
              message: "请输入整数数字",
              trigger: "blur"
            },
            {
              validator: (rule, value, callback) => {
                let v = this.xqyxForm.sngdzw;
                if (v != null && v != '' && v<18) {
                  callback(new Error("室内光地展位面积应在18平方米到400平方米之间"));
                } else if (v != null && v != '' && v>400) {
                  callback(new Error("室内光地展位面积应在18平方米到400平方米之间"));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
          ];
          break;
      }
    }
  }
};
</script>

<style lang="scss">
#qyyxEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/Xqyx.vue